import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';
import { IGame, IGamesProvider } from '../../../types';

export interface IGetGamesByLaunchIdsResponse {
  games: IGame[];
  providers: IGamesProvider[];
}

export const getGamesByLaunchIds = (
  launchIds: string[],
  useStatus: boolean = false
) =>
  get<IGetGamesByLaunchIdsResponse>(
    `/adm-gw01/public/gamesByLaunchIds?${
      useStatus ? 'status=all&' : ''
    }${launchIds
      .map((launchId) => `launchGameIds[]=${launchId}&`)
      .join('')
      .slice(0, -1)}` // remove last extra "&" sign in the end
  ).then((response) => camelizeKeys<IGetGamesByLaunchIdsResponse>(response));
